import { useEffect, useState, useCallback } from "react";
import { getResearchQueryByExecutionId } from "../services/ResearchQueriesService";
import { getResearchQueryRerunData } from "../services/researchQueryExecutionService";

interface FetchResearchQueryRerunDataProps {
  executionId: number | null;
  setIsLoading: (loading: boolean) => void
}

const useFetchResearchQueryRerunData = ({
  executionId,
  setIsLoading
}: FetchResearchQueryRerunDataProps) => {
  const [rerunData, setRerunData] = useState<any>(null);

  const fetchRerunData = useCallback(async () => {
    if (executionId && executionId > 0 ) {
      setIsLoading(true);
      try {
        const result = await getResearchQueryRerunData(
          executionId
        );
        setRerunData(result);
      } catch (error) {
        console.error("Error fetching research query re-run data:", error);
        setRerunData(null);
      } finally {
        setIsLoading(false);
      }
    }
  }, [
    executionId,
    setIsLoading
   
  ]);

  useEffect(() => {
    fetchRerunData();
  }, [fetchRerunData]);

  return [rerunData];
};

export default useFetchResearchQueryRerunData;
